import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button, Spinner } from '../components/';
import { TranslatedCopy } from '../intl/TranslatedCopy';
import { openModal, closeModal } from '../components/modal/actions';

const DeleteNotification = ({ notificationId, handleDelete, submitting, openModal, closeModal }) => {
  const handleConfirm = () => {
    handleDelete(notificationId);
    closeModal();
  };

  const handleDeleteClick = () => {
    openModal({
      type: 'alert',
      content: <TranslatedCopy id='notifications.form.delete.copy' />,
      confirmText: <TranslatedCopy id='notifications.delete' />,
      confirmAction: handleConfirm,
      cancelText: <TranslatedCopy id='global.cancel' />,
      cancelAction: closeModal
    });
  };

  return (
    <Button
      onClick={handleDeleteClick}
      extraClassName='ncss-btn-primary-dark u-full-width'
      data-desc='notificationsForm__button_delete'
    >
      {submitting ? <Spinner className='relative-container p3-sm' /> : <TranslatedCopy id='notifications.delete' />}
    </Button>
  );
};

DeleteNotification.defaultProps = {
  submitting: false
};

DeleteNotification.propTypes = {
  notificationId: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

const connector = connect(() => ({}), {
  openModal,
  closeModal
});

export default connector(DeleteNotification);
